import { ApplicationConfig, importProvidersFrom, isDevMode, provideZoneChangeDetection } from '@angular/core';
import { provideRouter, withComponentInputBinding } from '@angular/router';

import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { TIME_TO_REFRESH_TOKEN } from '@domain/constants/time-to-refresh-token.const';
import { environment } from '@environments/environment';
import { provideStore } from '@ngrx/store';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { APP_REDUCERS } from '@store/app.state';
import { AuthOptions, provideB2CAuth } from 'cve-auth';
import { routes } from './app.routes';
import { ACTIVITY_API_PROVIDER } from './features/activity/infrastructure/providers/activity.provider';
import { ADDRESS_BOOK_API_PROVIDER } from './features/address-book/infrastructure/providers/address-book.provider';
import { ACCOUNTS_API_PROVIDER } from './features/profile/infrastructure/providers/accounts.provider';
import { MRO_GPS_API_PROVIDER } from './features/vehicles/infrastructure/providers/mro-gps.provider';
import { MRO_MANUAL_API_PROVIDER } from './features/vehicles/infrastructure/providers/mro-manual.provider';
import { MRO_SMARTCAR_API_PROVIDER } from './features/vehicles/infrastructure/providers/mro-smartcar.provider';
import { VEHICLES_API_PROVIDER } from './features/vehicles/infrastructure/providers/vehicles.provider';
import { INVOICES_API_PROVIDER } from './features/wallet/infrastructure/providers/invoices.provider';
import { PAYMENTS_API_PROVIDER } from './features/wallet/infrastructure/providers/payments.provider';
import { authInterceptor } from './infrastructure/interceptors/auth.interceptor';
import { mockRoutingInterceptor } from './infrastructure/interceptors/mock.interceptor';
import { TranslationsModule } from './infrastructure/translations/translations.module';

const optionsAuthProvider: AuthOptions = {
    apiUrl: environment.url,
    timeToRefreshToken: TIME_TO_REFRESH_TOKEN,
    redirectLogoutRoute: 'login',
    b2c_Cname: environment.B2C_CNAME,
    b2c_Tenant: environment.B2C_TENANT,
    policy: environment.POLICY,
    applicationId: environment.APPLICATION_ID,
    applicationUrl: environment.APPLICATION_URL,
    applicationScope: environment.APPLICATION_SCOPE,
};

export const appConfig: ApplicationConfig = {
    providers: [
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withComponentInputBinding()),
        provideHttpClient(withFetch(), withInterceptors([mockRoutingInterceptor, authInterceptor])),
        provideB2CAuth(optionsAuthProvider),
        importProvidersFrom(TranslationsModule),
        ACCOUNTS_API_PROVIDER,
        PAYMENTS_API_PROVIDER,
        ADDRESS_BOOK_API_PROVIDER,
        VEHICLES_API_PROVIDER,
        MRO_SMARTCAR_API_PROVIDER,
        MRO_MANUAL_API_PROVIDER,
        MRO_GPS_API_PROVIDER,
        ACTIVITY_API_PROVIDER,
        INVOICES_API_PROVIDER,
        provideStore(APP_REDUCERS, {
            runtimeChecks: {
                // strictStateImmutability and strictActionImmutability are enabled by default
                strictStateSerializability: false,
                strictActionSerializability: false,
                strictActionWithinNgZone: true,
                strictActionTypeUniqueness: true,
                // if you want to change complexe objects and that we have. We need to disable these settings
                // change strictStateImmutability, strictActionImmutability
                strictStateImmutability: false,
                strictActionImmutability: false,
            },
        }),
        provideStoreDevtools({ maxAge: 25, logOnly: !isDevMode() }),
    ],
};
